import { nanoid } from "nanoid"
import { Skeleton } from "primereact/skeleton"

const ArticuloSkeleton = () => (
  <div className='articulo-catalogo'>
    <div className='wrap-left'>
      <div className='articulo-image'>
        <Skeleton
          width='3em'
          height='2em'
        />
      </div>
      <div className='articulo-referencia'>
        <Skeleton
          className='ml-2 mr-1'
          width='8em'
          height='1em'
        />
      </div>
      <div className='articulo-name'>
        <Skeleton
          className='ml-2'
          width='50%'
          height='1em'
        />
      </div>
    </div>

    <div className='ml-2 wrap-right'>
      <Skeleton
        width='14em'
        height='2.5em'
      />
      <span className='articulo-precio'>
        <Skeleton
          className='ml-3'
          width='5em'
          height='1em'
        />
      </span>
    </div>
  </div>
)

export const ArticulosSkeletons = ({ times, isGrid }: $TSMigrationFixMe) => {
  return [...new Array(times).keys()].map(() => (
    <ArticuloSkeleton
      key={nanoid()}
      // @ts-expect-error TS(2322): Type '{ key: string; isGrid: $TSFixMe; }' is not assign...
      isGrid={isGrid}
    />
  ))
}

export default ArticuloSkeleton
